export const EditScaleUsersCache = {
  key(groupID, scaleID) {
    return `@EDIT_SCALE_USERS::${groupID}::${scaleID}`
  },

  get(groupID, scaleID) {
    try {
      return JSON.parse(localStorage.getItem(this.key(groupID, scaleID)))
    } catch {
      return null
    }
  },

  set(groupID, scaleID, users, lastModified) {
    localStorage.setItem(
      this.key(groupID, scaleID),
      JSON.stringify({
        users,
        lastModified,
        savedAt: Date.now(),
      })
    )
  },
}

const ensureVersion = ({ table, version }) => {
  const STORAGE_TABLE_VERSION = `${table}_version`;
  const storedTableVersion = localStorage.getItem(STORAGE_TABLE_VERSION);

  if (storedTableVersion !== version) {
    Object.keys(localStorage).forEach(key => {
      if (key.startsWith(`${table}`)) {
        localStorage.removeItem(key);
      }
    });

    localStorage.setItem(STORAGE_TABLE_VERSION, version);
  }
}

export function useStorage({
  table,
  version
}) {
  ensureVersion({
    table,
    version
  });

  const buildKey = (key) => `${table}_${key}`;

  function get({
    key,
    fallback
  }) {
    try {
      const value = localStorage.getItem(buildKey(key));
      return value ? JSON.parse(value) : fallback;
    } catch (err) {
      localStorage.removeItem(buildKey(key));
      return fallback;
    }
  }

  function set({
    key,
    value
  }) {
    localStorage.setItem(buildKey(key), JSON.stringify(value));
  }

  function remove(key) {
    localStorage.removeItem(buildKey(key));
  }

  return { get, set, remove };
}
